import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { maskString, setApplicationQueryParam } from 'utils/functions'

import { Button, Modal } from 'components'
import ExpandedInfo from 'components/ExpandedInfo'
import Colors from 'utils/Colors'
import moment from 'moment'
import _ from 'lodash'
import Container from './styles'

const ApplicationInfo = (props) => {
  const { review } = props
  const history = useHistory()

  const [modalOpen, setModalOpen] = useState(false)
  const [selectedAppId, setSelectedAppId] = useState('')

  const handleOpenModal = (appId) => {
    setSelectedAppId(appId)
    setModalOpen(true)
    setApplicationQueryParam(history, appId)
  }

  const handleCloseModal = () => {
    setSelectedAppId(null)
    setModalOpen(false)
    setApplicationQueryParam(history)
  }

  const buildStatusInfo = (app) => {
    const defaultStatus = 'Em andamento'
    const statusDescription = app.detailed_status?.description || defaultStatus

    const statusColors = {
      APPROVED: Colors.approvedGreen,
      REPROVED: Colors.reprovedRed,
      default: Colors.ongoing,
    }

    const color = statusColors[app.status] || statusColors.default
    return <span style={{ color: color }}>{statusDescription}</span>
  }

  const app = review?.application || {}
  const applicantData = app?.candidate?.person || {}
  return (
    <React.Fragment>
      <Container>
        <h4>Candidato</h4>
        <p>
          <span>CPF: </span>
          {maskString(applicantData?.cpf, 'cpf')}
        </p>
        <p className="name">
          <span>Nome: </span>
          {applicantData?.name?.toLowerCase()}
        </p>
        <p>
          <span>Data de Nascimento: </span>
          {_.isEmpty(applicantData?.birth_date) ? '-' : moment(applicantData?.birth_date).format('DD/MM/yyyy')}
        </p>

        <br></br>

        <h4>Aplicação</h4>
        <p>
          <span>ID: </span>
          {app.uuid}
        </p>
        <p>
          <span>Especialidade: </span>
          {app.occupation_area}
        </p>
        <p>
          <span>Senioridade: </span>
          {app.job_role}
        </p>
        <p>
          <span>Recrutador: </span>
          {app.candidate?.recruiter_name || 'Informação indisponível'}
        </p>
        <p>
          <span>Status: </span>
          {buildStatusInfo(app)}
        </p>
        
        <br></br>

        <Button fontSize="1.2rem" onClick={() => handleOpenModal(app.uuid)}>Mais Detalhes</Button>
      </Container>

      {selectedAppId && (
        <Modal open={modalOpen} onClose={handleCloseModal} title="Informações detalhadas da aplicação">
          <ExpandedInfo handleClose={handleCloseModal} application_id={selectedAppId} />
        </Modal>
      )}
    </React.Fragment>
  )
}

export default ApplicationInfo
